<template>
  <div class="container-fluid">
    <Header/>
    <router-view/>
  </div>
</template>

<script>
import Header from '../../components/Header';

export default {
  name: 'Home',
  components: {
    Header
  }
}
</script>
